export default __webpack_public_path__ + "static/media/CNo.87-0.68d488b0.jpg";